import { render, staticRenderFns } from "./NotificationsModule.vue?vue&type=template&id=a04bc576&"
import script from "./NotificationsModule.vue?vue&type=script&lang=js&"
export * from "./NotificationsModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports